import React from "react";
import styled from "styled-components";
import { MotionConfig } from "framer-motion";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import GlobalStyle from "./styles/GlobalStyle";
import ScrollManager from "./components/ScrollManager";
import Navigation from "./components/Navigation";
import Footer from "./components/Footer";
import BackToTop from "./components/BackToTop";
import AIChatFloat from "./components/AIChatFloat";
import Home from "./pages/Home";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import TermsOfUse from "./pages/TermsOfUse";
import CookiePolicy from "./pages/CookiePolicy";
import LegalNotice from "./pages/LegalNotice";
import NotFound from "./pages/NotFound";

const SkipLink = styled.a`
  position: fixed;
  top: 12px;
  left: 12px;
  z-index: 200;
  padding: 10px 16px;
  border-radius: var(--radius);
  background: var(--color-ink);
  color: #fff;
  font-weight: 600;
  transform: translateY(-200%);
  transition: transform 0.2s ease;

  &:focus {
    transform: translateY(0);
  }
`;

function App() {
  return (
    <BrowserRouter>
      <MotionConfig reducedMotion="user">
        <GlobalStyle />
        <ScrollManager />
        <SkipLink href="#main">Skip to content</SkipLink>
        <Navigation />
        <main id="main">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/terms-of-use" element={<TermsOfUse />} />
            <Route path="/cookie-policy" element={<CookiePolicy />} />
            <Route path="/legal-notice" element={<LegalNotice />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </main>
        <Footer />
        <BackToTop />
        <AIChatFloat />
      </MotionConfig>
    </BrowserRouter>
  );
}

export default App;
